import { AlertColor } from "@mui/material";
import { IconCheckCircleInset } from "src/components/icons-mui/check-circle-inset";
import { IconInfo } from "src/components/icons-mui/info";

export interface IAlertSeverityIconProps {
    status: AlertColor;
}

export const AlertSeverityIcon = ({ status }: IAlertSeverityIconProps) => {
    switch (status) {
        case "info":
            return <IconInfo sx={{ fill: "common.white", color: "gray.800" }} />;
        case "success":
            return <IconCheckCircleInset sx={{ fill: "common.white", color: "green.600" }} />;
        case "error":
        case "warning":
            return (
                <IconInfo
                    sx={{
                        transform: "rotate(180deg)",
                        fill: "common.white",
                        color: status === "warning" ? "orange.600" : "red.600",
                    }}
                />
            );
        default:
            return null;
    }
};
